import { HttpContextToken } from "@angular/common/http";

// tokens
export const SHOULD_SUPRESS_ERROR_MESSAGE = new HttpContextToken<boolean>(() => false);
export const SHOULD_BUBBLE_ERROR = new HttpContextToken<boolean>(() => false);
export const API_ERROR_EVENT_TOKEN = "API_ERROR";

// rules
export const GLOBAL_NOTIFICATION_RULES = {
    allowedCodes: new RegExp("[4, 5][0 - 9][0 - 9]"),
    allowedMethods: ["GET"]
};
